export function progressColor(percent) {
	return `rgb(${250 - (percent > 0.5 ? 2 * (percent - 0.5) : 0) * 200},${
		15 + (percent < 0.5 ? 2 * percent : 1) * 200
	},0)`;
}
export function progressStepColor(percent) {
	if (percent > 0.7) {
		return "var(--lime-500)";
	}
	if (percent < 0.3) {
		return "var(--red-500)";
	}
	return "var(--amber-500)";
}
export function adjustValue(value) {
	if (value <= 1 && value >= 0) {
		return value;
	}
	if (value > 1) {
		return 1;
	}
	return 0;
}
